import { Link } from 'react-router-dom';
import Footer from '../components/Footer';


const imageBase = process.env.PUBLIC_URL || '';
const asset = (name) => `${process.env.PUBLIC_URL}/images/${name}`;

const heroProduct = {
  slug: "phoenix-jersey",
  image: `${imageBase}/images/fullImage.avif`,
  alt: "Phoenix Suns jersey front and back over purple background",
 
};
 
const gridItems = [
  {
    slug: "Compression-Shirt",
    image: `${imageBase}/images/compression_Shirt.avif`,
    alt: "Miami Heat black jersey, shorts on grey. Link to product page.",
    name: "Compression Sleeve",
    price: "$75",
  },
  {
    slug: "Basketball-Shorts",
    image: `${imageBase}/images/ball_shorts.avif`,
    alt: "Warriors black gold jersey. Link to product page",
    name: "3 Stripe Shorts",
    price: "$45",
  },
  {
    slug: "Y-3 Ant Jersey",
    image: `${imageBase}/images/jersey.avif`,
    alt: "Male model in Hollingsworth green t-shirt. link to product page.",
    name: "Y-3 Ant Jersey",
    price: "$120",
  },
  {
    slug: "the-grey-hoodie",
    image: asset('hoodie.avif'),
    alt: "male model in mint blue t-shirt/ link to detailed product page",
    name: "The Grey Hoodie",
    price: "$80",
  },
];
 
const rowItems = [

  {
    slug: "Ant Shoe 1",
    image: `${imageBase}/images/shoe_1.avif`,
    alt: "male model in a grey t-shirt. To product page",
    name: "Ant Shoe 1",
    price: "$100",
  },
  {
    slug: "Ant Shoe 2",
    image: `${imageBase}/images/shoe_2.avif`,
    alt: "blue and white basketball shorts to detailed product page",
    name: "Ant shoe 2",
    price: "$100",
  },
  {
    slug: "Ant Shoe 3",
    image: `${imageBase}/images/shoe_3.avif`,
    alt: "black basketball shorts with birds to detailed product page",
    name: "Ant Shoe 3",
    price: "$100",
  },
  {
    slug: "Ant Shoe 4",
    image: `${imageBase}/images/shoe_4.avif`,
    alt: "white and red basketball shorts with flower to detailed product page",
    name: "Ant Shoe 4",
    price: "$100",
  },
];
 
function ProductCard({ slug, image, alt, name, price }) {
  return (
    <Link to={`/product/${slug}`} className="product-card">
      <img className="product-card-image" src={image} alt={alt} />
      <div className="product-card-info">
        <p className="product-card-name">{name}</p>
        <h3 className="product-card-price">{price}</h3>
      </div>
    </Link>
  );
}
 
function StaticProductCard({ image, alt, name, price }) {
  return (
    <div className="product-card">
      <img className="product-card-image" src={image} alt={alt} />
      <div className="product-card-info">
        <p className="product-card-name">{name}</p>
        <h3 className="product-card-price">{price}</h3>
      </div>
    </div>
  );
}

export default function ProductPage() {
  return (
    <>
     <header>
          <nav className="nav-main">
            <h1>PeakPerformance</h1>
            <ul className="nav-menu">
              <li className="nav-item">
                <Link className="button-nav" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="button-nav" to="/about">About</Link>
              </li>
              <li className="nav-item">
                <Link className="button-nav" to="/contact">Contact</Link>
              </li>
              <li className="nav-item">
                <Link className="button-nav" to="/checkout">Checkout</Link>
              </li>
            </ul>
          </nav>
        </header>
    <section className="shop-all-page">
      
      <h1 className="shop-all-title">Shop All</h1>
 
      <div className="showcase-grid">
        <div className="hero-product">
          <img
            className="hero-product-image"
            src={heroProduct.image}
            alt={heroProduct.alt}
          />
          <div className="hero-product-info">
            <p className="hero-product-name">{heroProduct.name}</p>
            <h3 className="hero-product-price">{heroProduct.price}</h3>
          </div>
        </div>

        <div className="grid-quad">
          {gridItems.map((item) => (
            <ProductCard key={item.name} {...item} />
          ))}
        </div>
      </div>
 
      <div className="row-section">
        <h2 className="row-title">Complete the Look</h2>
        <div className="row-quad">
          {rowItems.map((item) => (
            <StaticProductCard key={item.name} {...item} />
          ))}
        </div>
      </div>
    </section>
     <Footer/>
    </>
  );
}